import { gql } from '@apollo/client'

export const CHART_CATEGORY = gql`
  query ChartCategory($chartId: Int!) {
    chartCategory(chartId: $chartId) {
      chartId
      id
      title
      ChartDataPoint {
        archivedAt
        chartCategoryId
        id
        date
        value
      }
    }
  }
`
